import React from 'react';
import PropTypes from 'prop-types';
import {Header} from '../../../Header';
import {ModalFooter} from '../ModalFooter';
import {ModalContent} from '../ModalContent';
import {SectionLeft} from '../SectionLeft';
import {ContentDescription} from '../ContentDescription';
import {GelContentsBlock} from '../GelContentsBlock';
import {SectionRight} from '../SectionRight';
import {GelLaneSelect} from '../GelLaneSelect';
import {GelLaneDeposit} from '../GelLaneDeposit';
import {GelLanePipette} from '../GelLanePipette';
import {GelOrientation} from '../GelOrientation';

import {OrientationStatusBlock} from '../OrientationStatusBlock';
import {OrientationControlBlock} from '../OrientationControlBlock';
import {VectorBlock} from '../VectorBlock';
import {GelLabTip} from '../GelLabTip';
import {ModalViewControls} from '../ModalViewControls';

import {Modal} from '@learningblocks/storybook-components';
import {
  NOTIFY_EVENTS,
  getTimeValues,
  getNewTime,
} from '../Gelbox.utils';
import './style.scss';

export function GelOrientationModal(props) {

  return (
    <Modal
      isOpen={props.isOpen}
      size={props.size}
      className="orientationModal"
    >
      <div>
        <Header
          label='ORIENTATE GEL'
          close={props.onClose}
          size='md'
        />
        <ModalContent className='orientationModal_content'>
          <SectionLeft className='orientationModal_content_left'>
            <VectorBlock className={'orientationModal_content_left_vectorblock'} />
            <ContentDescription
              className='orientationModal_content_left_contentDescription'
              title='Align the gel'
              description='Orient the wells of the gel towards the negative electrode.'
            />
            <OrientationControlBlock
              id={props.id}
              orientation={props.orientation}
              className='controlsModal_content_left_contents'
              lanes={props.lanes}
              decGelOrientation={props.decGelOrientation}
              incGelOrientation={props.incGelOrientation}
            />
          </SectionLeft>
          <SectionRight className='orientationModal_content_right'>
            <GelOrientation
              className='orientationModal_content_right_panel_top'
              lanes={props.lanes}
              alert={props.alert}
              orientation={props.orientation}
            />
          </SectionRight>
        </ModalContent>
        <ModalFooter
          text='Done'
          className='orientationModal_footer'
          onClick={props.onClose}
        />
      </div>
    </Modal>
  );
}

GelOrientationModal.propTypes = {
  /**
   * Function to alert event
   */
  alert: PropTypes.func,
  /**
   * Boolen to set if modal is displayed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to close the modal
   */
  onClose: PropTypes.func,
  /**
   * Boolean to set if the Microcentrifuge tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
  /**
   * Boolean to determine if centrifuge runnable
   */
  centrifugeRunnable: PropTypes.bool,
};

GelOrientationModal.defaultProps = {
  showClose: true,
  size: 'md',
};
